import { createContext } from 'react';

export interface FormTabRequest {
    name: string;
    // Changes on every request so repeated switches to the same tab re-trigger the effect
    token: number;
}

export interface FormTabControl {
    // External "switch to this tab" request; consumed by form layouts that own tab state
    requestedTab: FormTabRequest | null;
    // Fired when the user changes the tab (not on programmatic switches)
    onTabChanged?: (tabName: string) => void;
}

export const FormTabControlContext = createContext<FormTabControl>({ requestedTab: null });
